import Image from 'next/image';

import { Button, ButtonGroup, Paragraph } from '@zillow/constellation-10';
import { IconArrowLeftOutline, IconArrowRightOutline } from '@zillow/constellation-icons';

import HomeSearch from '../../assets/HomeSearch.svg';

import WizardBodyTemplate from '../WizardBodyTemplate';

import type { WizardBodyTemplateProps } from '../WizardStepController';

const WizFindListingSuccess = ({ onGoToNextStep, onGoToPrevStep, progressStepper }: WizardBodyTemplateProps) => {
  const renderSubtitle = () => (
    <>
      <Paragraph css={{ marginBottom: '600' }}>
        For security purposes, we will verify the contact information on your listings before allowing them to be linked
        to Zillow Rental Manager.
      </Paragraph>
      <Paragraph>
        To ensure all your listings are found, verify all phone numbers and email addresses you may have used.
      </Paragraph>
    </>
  );

  return (
    <WizardBodyTemplate
      title="Next, let’s verify your contact information"
      subtitle={renderSubtitle()}
      icon={<Image src={HomeSearch} alt="HomeSearch" fill />}
      progressStepper={progressStepper}
      footer={
        <ButtonGroup
          css={{ marginTop: 'auto', paddingTop: '600', justifyContent: 'center' }}
          aria-label="Find listing success"
        >
          <Button
            tone="brand"
            emphasis="outlined"
            onClick={onGoToPrevStep ?? undefined}
            disabled={!onGoToPrevStep}
            icon={<IconArrowLeftOutline />}
          >
            Back
          </Button>
          <Button
            tone="brand"
            emphasis="filled"
            onClick={onGoToNextStep ?? undefined}
            disabled={!onGoToNextStep}
            icon={<IconArrowRightOutline />}
          >
            Next
          </Button>
        </ButtonGroup>
      }
    />
  );
};

export default WizFindListingSuccess;
